import wrappedLocalStorage from 'flow/utils/local-storage-utils';

export const setAuthToken = (token: string) =>
    wrappedLocalStorage.setItem('authToken', token);
export const getAuthToken = () => wrappedLocalStorage.getItem('authToken');
export const removeAuthToken = () =>
    wrappedLocalStorage.removeItem('authToken');

export const generatePKCE = async () => {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    const arrJoinCodeVerifier = Array.from(array, (byte) =>
        String.fromCharCode(byte),
    ).join('');
    const codeVerifier = btoa(arrJoinCodeVerifier)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');

    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = new Uint8Array(hashBuffer);
    const arrJoinCodeChallenge = Array.from(hashArray, (byte) =>
        String.fromCharCode(byte),
    ).join('');
    const codeChallenge = btoa(arrJoinCodeChallenge)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');

    return { codeVerifier, codeChallenge };
};

export const parseJwt = (token: string) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const tokenComponent = atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('');
        const jsonPayload = decodeURIComponent(tokenComponent);
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Failed to parse JWT:', error);
        return null;
    }
};
